import { createAsyncThunk } from "@reduxjs/toolkit";
import GrafanaClient from "../../config/grafanaClient";
import {
  setActiveLocarionRow,
  setDetectionDetialsData,
  setDetectionDetialsGraphData,
  setDetectionSingleSubstanceFrequencyData,
  setLoaderDetectionDetialsData,
  setLoaderDetialsGraphData,
  setLoaderSingleSubstance,
  setMeasuremenDetectionDataNotFound,
} from "../slices/detectionSlice";
import { API, graphqlOperation } from "aws-amplify";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { getSingleSubstanceFrequencyQuery, getSubstanceDetail } from "../../graphql/queries";
import { ChangeServiceRequest } from "./commonThunk";
import { devApi, devApiMeasurementService, prodApi, prodApiMeasurementService, qaApi, qaApidevApiMeasurementService } from "../../aws-export";
import { RootState } from "../store";
import { convertTemperatureToCelsius } from "../../config/util";
import { aggSubstanceList, detectionAggSubstanceList, setMeasurementDataNotFound } from "../slices/substanceSlice";
import DashboardDummyData from './dashboard_dummydata.json'

export const getDetectionDetailsDataThunk = createAsyncThunk(
  "downloadDashboard",
  async (_request: any, { dispatch }) => {      
    try {            
      dispatch(setLoaderDetectionDetialsData(true));
      if(_request.tenantCode !== process.env.REACT_APP_TENANT_CODE){        
          const response = (await GrafanaClient().post(
            "/detection/get-detection-details-data",
            _request.request
          )) as { data: any; errors: any[] };
          console.log("getSubstanceDetails",response.data.data.getSubstanceDetails);
          if (response.data.data.getSubstanceDetails) {
            dispatch(
              setDetectionDetialsData(
                response.data?.data?.getSubstanceDetails?.measures
              )
            );
          }
      }else{
        dispatch(
            setDetectionDetialsData(DashboardDummyData?.DetectionDetails?.measures)
          );
      }
      dispatch(setLoaderDetectionDetialsData(false));
    } catch (err: any) {
      console.log("errerrerr", err);
      dispatch(setLoaderDetectionDetialsData(false));
    }
  }
);

export const getSingleSubstanceFrequencyThunk = createAsyncThunk(
  "getSubstanceFrequency",
  async (_request: any, { dispatch }) => {
    
    dispatch(setLoaderSingleSubstance(true))
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
              ? prodApi
              : devApi,
        })
      );            
      const response = await API.graphql({
          ...graphqlOperation(getSingleSubstanceFrequencyQuery, {singleSubstanceFrequencyRequest:_request}),
          authMode: "AMAZON_COGNITO_USER_POOLS",
        }) as { data: any, errors: any[] };        
          dispatch(setDetectionSingleSubstanceFrequencyData(response.data.getSubstanceFrequencyWithSubstance))                   
          dispatch(setLoaderSingleSubstance(false))
      } catch (err: any) {
        dispatch(setLoaderSingleSubstance(false))
        console.log('errerrerrerr',err ,_request);    
      }
  }
);

export const GetSubstanceDetailDetection = createAsyncThunk(
  "GetSubstanceDetail",
  async (_request: any, { dispatch, getState }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    const userData = (getState() as RootState)?.authReducer?.userData;
    try {
      dispatch(setActiveLocarionRow(_request.location))
      dispatch(setLoaderDetialsGraphData(true));      
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
                ? prodApiMeasurementService
                : devApiMeasurementService,
        })
      );
      const SubstanceDetails = (await API.graphql(
        graphqlOperation(getSubstanceDetail, { params: _request.request })
      )) as { data: any; errors: any[] };                 
      if (SubstanceDetails?.data?.getSubstanceDetails?.measures !== null) {            
          let location = _request.location;                
          let previousData = _request.previousData;                        
          let data = {..._request.previousData, [location]: SubstanceDetails?.data?.getSubstanceDetails }
          if (userData?.temperature_unit === 'C' && _request?.substanceKey === 'temperature') {
            const convertedData = SubstanceDetails?.data?.getSubstanceDetails?.measures?.map((value: any) => {
              const celsiusValue = convertTemperatureToCelsius(value?.value)?.onlyNumber;
              return {
                ...value,
                value: celsiusValue
              }
            })
            data = { ..._request.previousData, [location] :{...data, measures: convertedData}}
          }                      
          dispatch(
            setDetectionDetialsGraphData(data)
          );
      }else{
        if(_request.tenantCode === process.env.REACT_APP_TENANT_CODE){
           console.log('userDatauserData',userData);                            
          let location = _request.location;                
          let previousData = _request.previousData;                        
          let data = {..._request.previousData, [location]: DashboardDummyData.getSubstanceDetails }
          if (userData?.temperature_unit === 'C' && _request?.substanceKey === 'temperature') {
            const convertedData = DashboardDummyData.getSubstanceDetails.measures?.map((value: any) => {
              const celsiusValue = convertTemperatureToCelsius(value?.value)?.onlyNumber;
              return {
                ...value,
                value: celsiusValue
              }
            })
            data = { ..._request.previousData, [location] :{...data, measures: convertedData}}
          }                      
          dispatch(
            setDetectionDetialsGraphData(data)
          );
        }         
      }
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(setLoaderDetialsGraphData(false));
    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
      dispatch(setLoaderDetialsGraphData(false));
    }
  }
);

export const getDetectionAggMeasurements = createAsyncThunk(
  "getDetectionAggMeasurements",
  async (_request: any, { dispatch }) => {    
    try {  
      if(_request.tenantCode !== process.env.REACT_APP_TENANT_CODE){
            dispatch(setMeasuremenDetectionDataNotFound(false));
            const AggMeasurementsList = (await GrafanaClient().post(
              "/detection/get-detection-aggrement-data",
              _request.request
            )) as { data: any; errors: any[] };
            const measurements = [];
            if(AggMeasurementsList?.data?.data?.getAggMeasurements?.readings?.length){
                measurements.push(AggMeasurementsList?.data?.data?.getAggMeasurements);
            }
            if (measurements.length > 0) {
              dispatch(detectionAggSubstanceList(measurements));
            } else {        
              dispatch(setMeasuremenDetectionDataNotFound(true));
            }
            return measurements;
        }else{    
          dispatch(detectionAggSubstanceList(DashboardDummyData.detectionAggregateData));       
          return DashboardDummyData.detectionAggregateData
        }
      } catch (error) {
        dispatch(detectionAggSubstanceList([]));
        dispatch(notificationFail("Data Not Available in this Location"));
        throw error;
      } finally {

      }
  }
);